import { getOriginalSubtotal, getOriginalCurrencyNotes } from '../selectors';

const hideOriginalCurrencyDisclaimer = () => {
  const originalSubtotal = getOriginalSubtotal();
  const originalCurrencyNotes = getOriginalCurrencyNotes();
  originalSubtotal.style.display = 'none';
  if (originalCurrencyNotes) {
    originalCurrencyNotes.style.display = 'none';
  }
};

const showOriginalCurrencyDisclaimer = () => {
  const originalSubtotal = getOriginalSubtotal();
  const originalCurrencyNotes = getOriginalCurrencyNotes();
  originalSubtotal.style.display = 'inline';
  if (originalCurrencyNotes) {
    originalCurrencyNotes.style.display = 'inline';
  }
};

export { hideOriginalCurrencyDisclaimer, showOriginalCurrencyDisclaimer };
